import { useTranslations } from 'next-intl'

import { TRoomDetail } from '@/entities/room'

import { ExpandableText, Heading } from '../../common'

export type Props = Pick<TRoomDetail, 'additionalDescription'>

export const MobileAdditionalDescription = ({
  additionalDescription,
}: Props) => {
  const t = useTranslations('room_detail')

  return (
    <section className="space-y-4">
      <Heading size="small">{t('additional_details.title')}</Heading>
      <ExpandableText
        content={additionalDescription}
        lineClamp={10}
        className="typo-body2"
      />
    </section>
  )
}
